module.exports = __webpack_public_path__ + "img/vector-shape1.c3bae292.png";